<template>
  <div>
    <b-card
      no-body
    >
      <b-card-header>
        <h4> Operations Dashboard </h4>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="4">
            <b-form-group
              label="Date Range"
            >
              <flat-picker
                v-model="filters.date"
                :config="{ mode: 'range'}"
              />
            </b-form-group>
          </b-col>
        </b-row>

      </b-card-body>
    </b-card>
    <b-card
      v-if="initialError"
      no-body
    >
      <b-card-body>
        <b-alert
          variant="danger"
          :show="initialError ? true : false"
        >
          <div class="alert-body">
            <p class="mb-0">
              {{ initialError }}
            </p>
          </div>
        </b-alert>
      </b-card-body>
    </b-card>
    <div v-if="result && !initialError">
      <rack-group-wise-pickup
        :loading="initialLoader"
        :chart-data="result.rack_group_wise_pickup_info"
      />
      <user-wise-pickup
        :loading="initialLoader"
        :chart-data="result.user_wise_pickup_info"
      />
      <rack-sub-group-wise-pickup
        :loading="initialLoader"
        :chart-data="result.rack_sub_group_wise_pickup_info"
      />
      <rsg-user-wise-pickup
        :loading="initialLoader"
        :chart-data="result.rsg_user_wise_pickup_info"
      />
      <user-wise-verification
        :loading="initialLoader"
        :chart-data="result.user_wise_verification_info"
      />

      <user-wise-packing
        :loading="initialLoader"
        :chart-data="result.user_wise_packing_info"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {
  BCard, BCardHeader, BRow, BCol, BCardBody, BFormGroup, BAlert,
} from 'bootstrap-vue'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import moment from 'moment-timezone'
import RackGroupWisePickup from '@/components/Operations/Dashboard/RackGroupWisePickup.vue'
import UserWisePickup from '@/components/Operations/Dashboard/UserWisePickup.vue'
import RackSubGroupWisePickup from '@/components/Operations/Dashboard/RackSubGroupWisePickup.vue'
import RsgUserWisePickup from '@/components/Operations/Dashboard/RsgUserWisePickup.vue'
import UserWiseVerification from '@/components/Operations/Dashboard/UserWiseVerification.vue'
import UserWisePacking from '@/components/Operations/Dashboard/UserWisePacking.vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BRow,
    BCol,
    BCardBody,
    BFormGroup,
    FlatPicker,
    BAlert,
    RackGroupWisePickup,
    UserWisePickup,
    RackSubGroupWisePickup,
    RsgUserWisePickup,
    UserWiseVerification,
    UserWisePacking,
  },
  data() {
    return {
      filters: {
        date: null,
      },
      result: null,
      initialLoader: false,
      initialError: null,
    }
  },
  watch: {
    filters: {
      handler() {
        this.fetchDashboardData()
      },
      deep: true,
    },
  },
  created() {
    const date = moment().subtract(1, 'day').format('YYYY-MM-DD')
    this.filters = { date: `${date} to ${date}` }
  },
  methods: {
    async fetchDashboardData() {
      try {
        this.initialLoader = true
        this.initialError = null
        const [fromDate, toDate] = this.filters.date?.split(' to ') || ''
        const { data } = await axios.get('/operations/operations-dashboard', {
          params: {
            ...(fromDate && toDate ? {
              date_from: fromDate,
              date_to: toDate,
            } : {}),
          },
        })
        this.result = data
      } catch (error) {
        this.initialError = error?.response?.data?.error || 'Something went wrong!'
      } finally {
        this.initialLoader = false
      }
    },
  },

}
</script>
